import { getCancellationId } from './convertClassicToCloudy';
import setOngoingActionAndActionMessage from './setOngoingActionAndActionMessage';
import datapoints from '../datapoints';
import ActionMessageId from '../schema/ActionMessageId';
import ActionType from '../schema/ActionType';
import AttachmentFullViewState from '../schema/AttachmentFullViewState';
import cancelConvertClassicToCloudyAttachment from '../services/cancelConvertClassicToCloudyAttachment';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';

export default createLegacyActionWithDatapoint(
    'cancelConvertClassicToCloudy',
    datapoints.CancelConvertClassicToCloudy
)(function cancelConvertClassicToCloudy(attachmentViewState: AttachmentFullViewState) {
    const cancellationId: string = getCancellationId(attachmentViewState.attachmentId.Id);
    if (cancellationId) {
        setOngoingActionAndActionMessage(
            attachmentViewState,
            ActionType.ConvertClassicToCloudy,
            ActionMessageId.Canceling
        );
        cancelConvertClassicToCloudyAttachment(cancellationId);
    } else {
        throw new Error('Failed to find the cancellationId of ConvertClassicToCloudy');
    }
});
